import axios from "axios";
import { API_ROOT } from ".";
import { getAuthUser } from "./auth";

const HARVEST_LOGS_API_URL = `${API_ROOT}/harvest-logs`;

function getAuthHeaders(): { Authorization: string } {
  const authUser = getAuthUser();
  const token = authUser?.token;
  if (!token) throw new Error("Not authenticated");
  return { Authorization: `Bearer ${token}` };
}

export interface HarvestLogProduct {
  product: string;
  quantity: number;
}

export interface HarvestLog {
  logId: string;
  startDate: string;
  endDate: string;
  comment: string;
  products: HarvestLogProduct[];
}

export async function callFetchHarvestLogs(): Promise<HarvestLog[]> {
  const authUser = getAuthUser();
  const token = authUser?.token;
  if (!token) return [];
  const res = await axios.get<HarvestLog[]>(HARVEST_LOGS_API_URL, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return Array.isArray(res.data) ? res.data : [];
}

export async function callCreateHarvestLog(data: {
  startDate: string;
  endDate: string;
  comment?: string;
  products: HarvestLogProduct[];
}): Promise<HarvestLog> {
  const res = await axios.post<HarvestLog>(HARVEST_LOGS_API_URL, data, {
    headers: getAuthHeaders(),
  });
  return res.data;
}

export async function callDeleteHarvestLog(logId: string): Promise<void> {
  await axios.delete(`${HARVEST_LOGS_API_URL}/${logId}`, {
    headers: getAuthHeaders(),
  });
}

export async function callDeleteAllHarvestLogs(): Promise<void> {
  await axios.delete(HARVEST_LOGS_API_URL, {
    headers: getAuthHeaders(),
  });
}
